// src/utils/csvExport.js

// s9csv-4e1b7c28 — S9b (security audit #14): spreadsheet formula guard.
// A CSV cell whose text starts with = + - @ (or a tab / carriage return, which Excel strips before
// reading the rest) is run as a FORMULA when the file is opened in Excel or Google Sheets. Customer
// names and notes reach these exports from the public booking form, so a name typed as
// =HYPERLINK("http://evil",…) would become a live formula on a staff member's machine.
// Prefixing a single quote makes the spreadsheet show the text as text (Excel and Sheets hide the
// quote). Real numbers are left alone — a JS number, or a string that is only a number such as
// "-12.50" — so negative amounts still add up in the spreadsheet.
const FORMULA_START = /^[=+\-@\t\r]/;
const PLAIN_NUMBER = /^-?\d+(\.\d+)?$/;

export const neutralizeCsvCell = (value) => {
    if (typeof value !== 'string') return value;
    if (!FORMULA_START.test(value)) return value;
    if (PLAIN_NUMBER.test(value)) return value;
    return `'${value}`;
};

// For react-csv <CSVLink data=…>: rows as objects or arrays; every string value is guarded.
export const neutralizeCsvRows = (rows) => (Array.isArray(rows) ? rows.map((row) => {
    if (Array.isArray(row)) return row.map(neutralizeCsvCell);
    if (row && typeof row === 'object') {
        return Object.fromEntries(Object.entries(row).map(([k, v]) => [k, neutralizeCsvCell(v)]));
    }
    return neutralizeCsvCell(row);
}) : rows);

// One CSV cell: formula-guarded, double quotes doubled, wrapped in quotes.
export const csvCell = (value) => {
    let val = value;
    if (val === null || val === undefined) val = '';
    return `"${String(neutralizeCsvCell(val)).replace(/"/g, '""')}"`;
};

export const exportToCSV = (data, filename = 'export.csv') => {
    if (!data || !data.length) {
        alert("No data to export!");
        return;
    }

    // 1. Extract Headers from the first object
    const headers = Object.keys(data[0]);

    // 2. Convert Data to CSV String — every cell (headers included) goes through csvCell
    //    (formula guard + quote escaping + wrapping in quotes for embedded commas).
    const csvContent = [
        headers.map(csvCell).join(','), // Header Row
        ...data.map(row => headers.map(header => csvCell(row[header])).join(','))
    ].join('\n');

    // 3. Trigger Download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
